import { useTranslation } from 'react-i18next'
import * as z from 'zod'

import { useCommonSchema } from './commonSchema'

export const useCreateProfileSchema = ({
  isEmailRequired = false,
}: {
  isEmailRequired?: boolean
}) => {
  const { t } = useTranslation()

  const { firstName, lastName, username, email } = useCommonSchema()

  const createProfileSchema = z.object({
    firstName,
    lastName,
    username,
    email: isEmailRequired
      ? email
      : z.string().email(t('form:validationErrors.invalidEmail')).optional(),
    referralCode: z
      .string()
      .optional()
      .refine((val) => !val || val.length >= 3, 'Minimum 3 characters'),
    imageUri: z.string().optional(),
  })

  return createProfileSchema
}
export type ICreateProfileSchema = z.infer<
  ReturnType<typeof useCreateProfileSchema>
>
